var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"menu-item transition",class:{
    'is-active-blue': _vm.isActive && _vm.getTheme === 'blue' ? _vm.isActive(): null,
    'is-active-green': _vm.isActive && _vm.getTheme === 'green' ? _vm.isActive(): null,
    'hover:bg-blue-logo focus:bg-blue-logo': _vm.getTheme === 'blue',
    'hover:bg-green-logo focus:bg-green-logo': _vm.getTheme === 'green'
  },attrs:{"title":_vm.title},on:{"click":_vm.action}},[(_vm.icon)?_c('svg',{staticClass:"remix"},[_c('use',{attrs:{"xlink:href":`${_vm.remixiconUrl}#ri-${_vm.icon}`}})]):_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }